/**
 * Shared types and enums for Permanent Jobs events
 * Only types used by multiple events should be defined here
 */

// Tab names for job overview navigation
export enum JobOverviewTab {
  JobDetails = 'job_details',
  Candidates = 'candidates',
  OnsiteInterviews = 'onsite_interviews',
}

// Actions available in the candidate list
export enum CandidateAction {
  Reject = 'reject',
  Review = 'review',
  Hire = 'hire',
  Message = 'message',
}
